import { z } from "zod";

export const variationSchema = z
  .object({
    id: z.uuid(),
    slug: z.string(),
    target: z.url().nullable(),
    allocationPercent: z.int().min(0).max(100),
    isWinner: z.boolean().nullish(),
  })
  .describe("Variation");
